import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const validationSchema = Yup.object().shape({
  materials: Yup.array().of(
    Yup.object().shape({
      materialType: Yup.object().nullable().shape({
        materialTypeId: Yup.string().nullable(),
        commonName: Yup.string().nullable(),
      }),
      newWip: Yup.number().nullable().required('Actual WIP is required.'),
      newWipCost: Yup.number().nullable().required('Actual WIP Cost is required.'),
    }),
  ),
  effectiveDate: Yup.string().nullable().required('Effective Date is required.'),
  notes: Yup.string().nullable(),
})

export const formOptions = { resolver: yupResolver(validationSchema) }

export default validationSchema
